<div id="{{idPrefix}}{{target}}" class="row">

    <!-- LEFT COLUMN WITH WORKFLOW LIST -->

    <div class="col-sm-12 col-md-4">

        <mat-card>
            <mat-card-content>

                <create-name #createNameComponent
                             [idPrefix]="(idPrefix + 'new.')"
                             (nameEntered)="create($event)">
                </create-name>

                <!-- Below template is passed on to the action list to replace the default appearance -->
                <ng-template #customActionListTemplate
                             let-workflow="data">
                    <span class="action-list-display-name" *ngIf="workflowList">{{ workflow.actionListDisplayName | translate }}

                        <!-- ACTIVE / INACTIVE ICONS -->

                        <i class="dr-fa-icon dr-fa-icon-action-list fas fa-check"
                           matTooltip="{{ 'client_user.state.active' | translate }}"
                           *ngIf="workflow.active">
                        </i>

                        <i class="dr-fa-icon dr-fa-icon-action-list fas fa-ban"
                           matTooltip="{{ 'client_user.state.inactive' | translate }}"
                           *ngIf="!workflow.active">
                         </i>
                    </span>

                </ng-template>

                <action-list *ngIf="workflowList"
                             [idPrefix]="idPrefix"
                             [items]="workflowList.items"
                             [selected]="selected"
                             [identifier]="'id'"
                             [options]="actionListOptions"
                             [template]="customActionListTemplate"
                             [reorderable]="true"
                             (reordered)="reorderWorkflows()"
                             (select)="select($event)"
                             (copy)="copy($event)"
                             (delete)="delete($event)">
                </action-list>

            </mat-card-content>
        </mat-card>

    </div>


    <!-- RIGHT COLUMN WITH SELECTED WORKFLOW -->

    <div class="col-sm-12 col-md-8">

        <div class="row">

            <div class="col-12">
                <mat-tab-group #tabGroup class="smp-tab-style"
                               [animationDuration]="'0ms'"
                               (selectedIndexChange)="selectTab()">

                    <mat-tab *ngFor="let tab of tabs; let idx = index" label="{{ tab.label | translate }}" id="{{idPrefix}}selected.tab_{{idx}}">
                        <div class="mt-4 mb-4"
                             *ngIf="selected?.getSection(selected?.getSections().DEFAULTS)">

                            <case-workflow-participants *ngIf="selectedTabContentCode === tab.code && tab.code === CaseWorkflowSettingsTypes.PARTICIPANTS"
                                                        [idPrefix]="(idPrefix + 'selected_wf.')"
                                                        [workflow]="selected">
                            </case-workflow-participants>

                            <case-workflow-distribution *ngIf="selectedTabContentCode === tab.code && tab.code === CaseWorkflowSettingsTypes.DISTRIBUTIONS"
                                                        [idPrefix]="(idPrefix + 'selected_wf.')"
                                                        [workflow]="selected">
                            </case-workflow-distribution>

                        </div>
                    </mat-tab>

                </mat-tab-group>
            </div>
        </div>

    </div>

</div>

